"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAffiliateURL = exports.getAffiliateCodeForRedirect = exports.ccbillCookieName = exports.mamIdentCookieName = exports.mamCookieName = void 0;
const billers_1 = require("../constants/billers");
const mamURLTemplate = 'https://$ACCESS_SUBDOMAIN.$DOMAIN/track/$CODE/$PATH';
const mamURLTemplateRedirect = 'https://$ACCESS_SUBDOMAIN.$DOMAIN/track/$CODE/$PATH?url=$REDIRECT';
const ccbillURLTemplate = 'https://$SITE_SUBDOMAIN.$DOMAIN/$PATH?PA=$CODE';
const ccbillURLTemplateRedirect = '$REDIRECT?PA=$CODE';
exports.mamCookieName = 'mam';
exports.mamIdentCookieName = 'mamident';
exports.ccbillCookieName = 'PA';
const AffiliateCookies = [exports.mamCookieName, exports.mamIdentCookieName, exports.ccbillCookieName];
const BillerCookieNameMap = {
    [billers_1.Biller.RocketGate]: exports.mamCookieName,
    [billers_1.Biller.CCBill]: exports.ccbillCookieName,
};
const AffiliateUrlMap = {
    [exports.mamCookieName]: mamURLTemplate,
    [exports.ccbillCookieName]: ccbillURLTemplate,
};
const AffiliateRedirectUrl = {
    [exports.mamCookieName]: mamURLTemplateRedirect,
    [exports.ccbillCookieName]: ccbillURLTemplateRedirect,
};
const AffiliateRedirectFormatter = {
    [exports.mamCookieName]: (url) => encodeURIComponent(url),
    [exports.ccbillCookieName]: (url) => url,
};
const RocketGatePartnerCodes = {
    '2163551d-11d0-4396-86ad-9d291c8dfd71': '7',
    'd0e7e333-2931-1e3b-b6e0-800200c93255': '32',
    'fda02100-4e34-11df-9879-0800200c9a66': '32',
    '15a9ffa0-4e35-11df-9879-0800200c9a66': '32',
    '706df46b-8888-4f7b-b226-097952427754': '41',
    '5592e333-2421-1e3f-f640-800200c93111': '32',
    '605315cf-a263-6914-2d71-5ee4e9ed534e': '32',
    'e6b59510-4e34-11df-9879-0800200c9a66': '32',
    'e7dfb70d-f31c-45b3-b5e0-bf10d733d349': '32',
    'd99236c0-4dd0-11e1-b86c-0800200c9a66': '36',
    '94db3d00-36fc-11e1-b86c-0800200c9a66': '32',
    '18a2e47e-aefd-45f2-9033-a5fcaf1f5b91': '21',
    'fdafdf20-9dc3-11e0-aa82-0800200c9a66': '32',
    '4f230289-82b5-42fa-9c6d-aaa747e9b5b3': '32',
    '3d345d1e-1569-10b4-4db5-a80cdd746318': '32',
};
const CCBillPartnerToAnySiteCodes = {
    '2163551d-11d0-4396-86ad-9d291c8dfd71': '2383663',
    '706df46b-8888-4f7b-b226-097952427754': '2404629',
    'd99236c0-4dd0-11e1-b86c-0800200c9a66': '2372899',
    '18a2e47e-aefd-45f2-9033-a5fcaf1f5b91': '2408576',
};
const CCBillCoreToPartnerCodes = {
    '2163551d-11d0-4396-86ad-9d291c8dfd71': '2383445',
    '706df46b-8888-4f7b-b226-097952427754': '2404625',
    'd99236c0-4dd0-11e1-b86c-0800200c9a66': '2373290',
    '18a2e47e-aefd-45f2-9033-a5fcaf1f5b91': '2404624',
};
const RocketGateTrackingCodes = {
    '2163551d-11d0-4396-86ad-9d291c8dfd71': 'ALS.8.15.5.0.0',
    'd0e7e333-2931-1e3b-b6e0-800200c93255': 'DM.18.117.5.0.0',
    'fda02100-4e34-11df-9879-0800200c9a66': 'EB.2.4.5.0.0',
    '15a9ffa0-4e35-11df-9879-0800200c9a66': 'EA.6.9.5.0.0',
    '706df46b-8888-4f7b-b226-097952427754': 'ED.9.20.5.0.0',
    '5592e333-2421-1e3f-f640-800200c93111': 'GN.19.118.5.0.0',
    '605315cf-a263-6914-2d71-5ee4e9ed534e': 'LH.25.386.5.0.0',
    'e6b59510-4e34-11df-9879-0800200c9a66': 'MA.1.2.5.0.0',
    'e7dfb70d-f31c-45b3-b5e0-bf10d733d349': 'MX.23.255.5.0.0',
    'd99236c0-4dd0-11e1-b86c-0800200c9a66': 'RA.12.25.5.0.0',
    '94db3d00-36fc-11e1-b86c-0800200c9a66': 'SA.13.27.5.0.0',
    '18a2e47e-aefd-45f2-9033-a5fcaf1f5b91': 'S18.16.35.5.0.0',
    'fdafdf20-9dc3-11e0-aa82-0800200c9a66': 'TLE.14.29.5.0.0',
    '4f230289-82b5-42fa-9c6d-aaa747e9b5b3': 'VT.15.32.5.0.0',
    '3d345d1e-1569-10b4-4db5-a80cdd746318': 'SL.26.1163.5.0.0',
};
const PartnerSites = [
    '2163551d-11d0-4396-86ad-9d291c8dfd71',
    '706df46b-8888-4f7b-b226-097952427754',
    'd99236c0-4dd0-11e1-b86c-0800200c9a66',
    '18a2e47e-aefd-45f2-9033-a5fcaf1f5b91',
];
const getAffiliateCodeForRedirect = (firstPurchase, siteToVisitUUID) => {
    // if they haven't made a purchase we aren't going to cookie them
    // the user is basically a guest user, since they have never purchased anything
    if (!firstPurchase) {
        return undefined;
    }
    // don't apply the partner code if the first purchase site matches the site to visit
    if (firstPurchase.siteUUID === siteToVisitUUID) {
        return undefined;
    }
    // if the first purchase site and the site to visit are core sites, then we won't attach any partner codes
    if ([firstPurchase.siteUUID, siteToVisitUUID].every((siteUUID) => !PartnerSites.includes(siteUUID))) {
        return undefined;
    }
    let partnerCode;
    const isCoreSite = !PartnerSites.includes(firstPurchase.siteUUID);
    const cookieName = BillerCookieNameMap[firstPurchase.billerID];
    // the way we choose the partner code is based off biller, but can also be based off which site is the first purchase or that we want to visit
    switch (cookieName) {
        case exports.mamCookieName: {
            partnerCode = RocketGatePartnerCodes[firstPurchase.siteUUID];
            break;
        }
        case exports.ccbillCookieName: {
            partnerCode = isCoreSite
                ? CCBillCoreToPartnerCodes[siteToVisitUUID]
                : CCBillPartnerToAnySiteCodes[firstPurchase.siteUUID];
            break;
        }
        default:
            return undefined;
    }
    let rocketGateTrackingCode;
    // combine partner code with tracking code to get full RG MAM code
    if (firstPurchase.billerID === billers_1.Biller.RocketGate) {
        rocketGateTrackingCode = `${partnerCode}.${RocketGateTrackingCodes[siteToVisitUUID]}`;
    }
    if (cookieName && partnerCode) {
        return { [cookieName]: rocketGateTrackingCode || partnerCode };
    }
};
exports.getAffiliateCodeForRedirect = getAffiliateCodeForRedirect;
const createAffiliateURL = (params) => {
    const { accessSubdomain, affiliateCode, path, queryStringParams, redirect, siteDomain, siteSubdomain } = params;
    let url = redirect ? redirect : `https://$SITE_SUBDOMAIN.$DOMAIN/$PATH`;
    if (affiliateCode) {
        const [[cookieName, code]] = Object.entries(affiliateCode);
        url = (redirect ? AffiliateRedirectUrl[cookieName] : AffiliateUrlMap[cookieName])
            .replace('$ACCESS_SUBDOMAIN', accessSubdomain)
            .replace('$CODE', code)
            .replace('$REDIRECT', redirect ? AffiliateRedirectFormatter[cookieName](redirect) : '');
    }
    const searchParams = new URLSearchParams();
    if (queryStringParams) {
        Object.entries(queryStringParams).forEach(([key, value]) => {
            if (value !== undefined && value !== '') {
                searchParams.set(key, value.toString());
            }
        });
    }
    const querystring = searchParams.toString();
    if (querystring) {
        url = url.includes('?') ? `${url}&${querystring}` : `${url}?${querystring}`;
    }
    return url
        .replace('$SITE_SUBDOMAIN', siteSubdomain)
        .replace('$DOMAIN', siteDomain)
        .replace('$PATH', path || '');
};
exports.createAffiliateURL = createAffiliateURL;
